export default {"src":"/_next/static/media/shopping-store.2c10ac49.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};